export const downloadFile = (object: File | Blob | MediaSource, fileName: string) => {
  const downloadUrl = window.URL.createObjectURL(object);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
